var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28509 3.55425C9.48596 3.21151 9.85979 3 10.2646 3H14.2482C14.653 3 15.0269 3.21151 15.2277 3.55425L16.9542 6.5H20.8718C21.4949 6.5 22 6.9925 22 7.6V19.4C22 20.0075 21.4949 20.5 20.8718 20.5H3.12821C2.50511 20.5 2 20.0075 2 19.4V7.6C2 6.99249 2.50511 6.5 3.12821 6.5H7.55864L9.28509 3.55425ZM10.8003 5L9.07388 7.94575C8.87301 8.28849 8.49919 8.5 8.09433 8.5H4.05128V18.5H19.9487V8.5H16.4185C16.0136 8.5 15.6398 8.28848 15.4389 7.94575L13.7125 5H10.8003Z",
    fill: "#1A2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2564 15C13.3893 15 14.3077 14.1046 14.3077 13C14.3077 11.8954 13.3893 11 12.2564 11C11.1235 11 10.2051 11.8954 10.2051 13C10.2051 14.1046 11.1235 15 12.2564 15ZM12.2564 17C14.5222 17 16.3589 15.2091 16.3589 13C16.3589 10.7909 14.5222 9 12.2564 9C9.99059 9 8.15381 10.7909 8.15381 13C8.15381 15.2091 9.99059 17 12.2564 17Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ab554c274036ce2dcd4c471e2a5ded37.svg";
export { ForwardRef as ReactComponent };